var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVideoChat = function SvgVideoChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1384 36.6767V20.0613C11.1384 18.2767 12.6154 16.7998 14.4 16.7998H32.1846H41.0769M53.2307 44.7998V32.4306V28.0921",
    stroke: "black",
    strokeWidth: 1.24631,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2616 44.8613H27.7539C27.7539 46.0921 28.7385 46.6459 29.9693 46.6459H34.4616C35.6923 46.6459 36.677 46.0921 36.677 44.8613H53.2923H57.1693V47.0152C57.1693 48.3075 56.1231 49.3536 54.8308 49.3536H16.3693",
    stroke: "black",
    strokeWidth: 1.24631,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 50.8306C15.9085 50.8306 19.0769 47.6622 19.0769 43.7537C19.0769 39.8452 15.9085 36.6768 12 36.6768C8.09153 36.6768 4.9231 39.8452 4.9231 43.7537C4.9231 47.6622 8.09153 50.8306 12 50.8306Z",
    stroke: "black",
    strokeWidth: 1.24631,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9385 49.6616L17.1077 53.7232H6.89233L8.06157 49.6616",
    stroke: "black",
    strokeWidth: 1.24631,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 46.8306C13.6993 46.8306 15.0769 45.453 15.0769 43.7537C15.0769 42.0544 13.6993 40.6768 12 40.6768C10.3007 40.6768 8.9231 42.0544 8.9231 43.7537C8.9231 45.453 10.3007 46.8306 12 46.8306Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2616 36.0615V37.9077",
    stroke: "black",
    strokeWidth: 1.24631,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1847 36.0615V37.9077",
    stroke: "black",
    strokeWidth: 1.24631,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1693 36.0615V37.9077",
    stroke: "black",
    strokeWidth: 1.24631,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7231 34.8311V39.1387",
    stroke: "black",
    strokeWidth: 1.24631,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6462 34.8311V39.1387",
    stroke: "black",
    strokeWidth: 1.24631,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.1385 26.4614C39.1385 28.4922 40.8001 30.1537 42.8309 30.1537H55.1385C57.1693 30.1537 58.8309 28.4922 58.8309 26.4614V14.1537C58.8309 12.123 57.1693 10.4614 55.1385 10.4614H42.8309C40.8001 10.4614 39.1385 12.123 39.1385 14.1537V26.4614ZM50.3386 16.246C50.7693 16.6153 51.0155 17.1691 51.0155 17.7845V18.0307C50.8924 19.0153 50.0309 19.8153 48.9847 19.8153C47.877 19.8153 46.9539 18.8922 46.9539 17.7845V17.4768C47.077 16.4922 47.9385 15.7537 48.9847 15.7537H49.2309C49.6616 15.8153 50.0309 15.9999 50.3386 16.246ZM52.8616 21.9691L53.2924 24.8614H44.677L45.1078 21.9691C45.2309 21.1691 45.9078 20.6153 46.7078 20.6153H48.9847H51.2616C52.0616 20.6153 52.7386 21.2307 52.8616 21.9691Z",
    fill: "#2F6D7B"
  })));
};
export default SvgVideoChat;